import { useEffect, useState } from "react";
import { useMap } from "maplibre-react-components";
import type { Map as MapLibreMap } from "maplibre-gl";
import { useTariffLayer } from "@/store/mode";
import { tariffModeToLayer } from "@/types/base";

export const usePinPrice = (mapId: string) => {
  const map = useMap(mapId) as MapLibreMap | null;

  const tariffLayer = useTariffLayer((s) => s.getLayer());
  const loaded = map?.isStyleLoaded();

  const [price, setPrice] = useState<number | null>(null);

  const updatePrice = () => {
    if (!map) return;

    const centerPoint = map.project(map.getCenter());
    if (!map.getLayer("hex-fill")) return;

    const features = map.queryRenderedFeatures([centerPoint.x, centerPoint.y], {
      layers: ["hex-fill"],
    });

    const p = features[0]?.properties?.[tariffModeToLayer[tariffLayer]];

    setPrice(p != null ? Number(p) : null);
  };

  useEffect(() => {
    if (!map) return;

    map.on("move", updatePrice);
    map.on("load", updatePrice);
    map.on("dragend", updatePrice);
    updatePrice();

    return () => {
      map.off("move", updatePrice);
      map.off("load", updatePrice);
      map.off("dragend", updatePrice);
    };
  }, [loaded, tariffLayer]);

  return price;
};
